import {
  BackendPropertyFilterQuery,
  BackendPropertyFilterToken,
} from "../server-side-table/propertyFilterTransform";

export interface BuildPropertyFilterQueryParams {
  gaiaObjectId: string | undefined;
  parentId: string;
  associatedEventIds: string[];
  existingTokens: BackendPropertyFilterToken[];
  existingOperation: "and" | "or";
}

export function buildPropertyFilterQuery(
  params: BuildPropertyFilterQueryParams,
): BackendPropertyFilterQuery | undefined {
  const {
    gaiaObjectId,
    parentId,
    associatedEventIds,
    existingTokens,
    existingOperation,
  } = params;

  if (!gaiaObjectId || gaiaObjectId !== parentId) {
    return undefined;
  }

  const gaiaObjectIdToken: BackendPropertyFilterToken = {
    propertyKey: "gaiaObjectId",
    operator: "=",
    value: gaiaObjectId,
  };

  const userFilterGroups: BackendPropertyFilterQuery[] =
    existingTokens.length > 0
      ? [{ operation: existingOperation, tokens: existingTokens }]
      : [];

  if (associatedEventIds.length > 0) {
    const eventParentIdToken: BackendPropertyFilterToken = {
      propertyKey: "parentId",
      operator: "in",
      values: associatedEventIds,
    };
    return {
      operation: "and",
      tokens: [],
      groups: [
        {
          operation: "or",
          groups: [
            { operation: "and", tokens: [gaiaObjectIdToken] },
            { operation: "and", tokens: [eventParentIdToken] },
          ],
        },
        ...userFilterGroups,
      ],
    };
  }

  return {
    operation: "and",
    tokens: [],
    groups: [
      { operation: "and", tokens: [gaiaObjectIdToken] },
      ...userFilterGroups,
    ],
  };
}
